import { useTranslation } from 'react-i18next';
import { ChevronLeft, HelpCircle, History, X } from 'lucide-react';
import {
  AmbossActionBar,
  AmbossHeaderBar,
  AmbossHeaderTitle,
  AmbossIconButton,
} from './amboss.styles';
import { useAmboss } from './useAmboss';

export function AmbossHeader() {
  const { t } = useTranslation();
  const { overlay, query, back, hideOverlay, showHelp, showHistory, close } = useAmboss();

  const title = query || t('amboss.searchPanel.title');
  const onBack = overlay !== 'none' ? hideOverlay : back;

  return (
    <AmbossHeaderBar>
      <AmbossIconButton aria-label={t('amboss.actions.back')} onClick={onBack}>
        <ChevronLeft size={20} />
      </AmbossIconButton>
      <AmbossHeaderTitle data-ph-no-autocapture>{title}</AmbossHeaderTitle>
      <AmbossActionBar $spacious>
        <AmbossIconButton
          $compact
          aria-label={t('amboss.actions.history')}
          onClick={showHistory}
          $active={overlay === 'history'}
        >
          <History size={20} />
        </AmbossIconButton>
        <AmbossIconButton
          $compact
          aria-label={t('amboss.actions.help')}
          onClick={showHelp}
          $active={overlay === 'help'}
        >
          <HelpCircle size={20} />
        </AmbossIconButton>
        <AmbossIconButton $compact aria-label={t('amboss.actions.close')} onClick={close}>
          <X size={20} />
        </AmbossIconButton>
      </AmbossActionBar>
    </AmbossHeaderBar>
  );
}
